<template>
  <div class='comparison-container' :class="[visibleFixed ? 'comparison-container-has-padding' : '']">
    <zm-table
      class="fbc-comparison comparison-table-new"
      :class="[isAllowExpand ? 'comparison-table-disabled-expand' : '']"
      ref="comparisonTable"
      :show-header="showHeader !== 'NOT'"
      :span-method="arraySpanMethod"
      :use-flip="false"
      :data="treeData"
      :expand-row-keys="defaultExpandRowKeys"
      :indent="0"
      row-key="id"
      stripe
      :key="resetTableData"
      :tree-props="{ children: 'children' }"
      @row-click="handleRowClickDefault"
      @expand-change="handleExpandChange"
      header-row-class-name="new-ui-style comparison-table-header"
      header-cell-class-name="comparison-table-header-cell"
      :row-class-name="tableRowClassName"
      :max-height="maxHeight"
      v-bind="tableProps"
      v-on="$listeners"
      style="width: 100%"
    >
      <zm-table-column
        fixed
        class-name="feature-col"
        prop="feature"
        min-width="180"
        label=""
      >
        <span slot="header" tabindex="0" class="table-th-first-span"></span>
        <template slot-scope="scope">
          <div
            class="feature-title-wrapper"
            :class="scope.row.subTitle ? `${scope.row.id}-sub-title` : ''"
          >
          <span tabindex="-1" class="feature-content" :class="[scope.row.subTitle ? 'sub-title' : 'sub-text']">
            <span v-if="scope.row.icon" :class="['table-feature-icon', 'icon-'+scope.row.icon]"></span>
            <span class="table-feature-title" v-html="scope.row.feature"></span>
            <zm-tooltip placement="top">
              <div slot="content" v-html="scope.row.tooltip" />
              <button
                class="button-icon"
                v-if="scope.row.tooltip"
                :aria-label="scope.row.feature"
                tabindex="-1"
                @mouseenter="mouseInToolTip(scope.row)"
              >
                <span class="sr-only"> {{ t("marketing.helpTooltipIcon") }}</span>
                <i class="zm-icon-info-outline"></i>
              </button>
            </zm-tooltip>
          </span>
          <auto-expire-badge :badgeId="scope.row.badgeId" :theme="'comparison'" />
            <a
              tabindex="-1"
              v-if="scope.row.pdf"
              href="https://explore.zoom.us/docs/doc/Phone-NomadicE911-6-2020.pdf"
              target="_blank"
              style="color: #0e71eb;"
            >{{ t("marketing.phone.fullPlanItem20Pdf") }}</a
            >
            <div v-if="scope.row.link">
              <a
                tabindex="-1"
                :class="scope.row.link.classname || ''"
                v-if="scope.row.link.callback"
                href="javascript:void(0);"
                @click="scope.row.link.callback"
                :style="scope.row.link.style || {}"
                :aria-label="scope.row.link.ariaLabel || scope.row.link.text"
              >{{ scope.row.link.text }}</a
              >
            </div>
          </div>
        </template>
      </zm-table-column>
      <!--col config start-->
      <zm-table-column
        v-for="(col, idx) in colConfig"
        :key="col.key + idx"
        min-width="180"
        :align="isCenter ? 'center' : 'left'"
      >
        <slot name="comparison-table-header" slot="header" :col="col"></slot>
        <template slot-scope="scope">
          <template>
            <template v-if="scope.row.isString">
            <span
              tabindex="-1"
              v-html="scope.row[col.key]"
              v-if="scope.row[col.key] !== true && scope.row[col.key]"
            ></span>
              <i
                tabindex="-1"
                class="zm-icon-ok"
                :aria-label="t('marketing.included')"
                v-else-if="scope.row[col.key] === true"
              ></i>
              <i
                tabindex="-1"
                class="zm-icon-minus"
                :aria-label="t('marketing.notIncluded')"
                v-else
              ></i>
              <div
                tabindex="-1"
                class="cell-desc"
                v-if="col.key === 'enterprise' && scope.row.enterpriseDesc"
              >
                *{{ scope.row.enterpriseDesc }}
              </div>
              <div v-if="isObject(scope.row.extraLink) && isObject(scope.row.extraLink[col.key]) && scope.row.extraLink[col.key]['text']">
                <a
                  :class="['comparison-extra-link__text', scope.row.extraLink[col.key].disabled ? 'comparison-extra-link__disabled' : '']"
                  tabindex="0"
                  :aria-label="scope.row.extraLink[col.key].text"
                  @keydown.enter.prevent="scope.row.extraLink[col.key].callback && scope.row.extraLink[col.key].callback()"
                  @click.prevent="scope.row.extraLink[col.key].callback && scope.row.extraLink[col.key].callback()"
                >
                  {{ scope.row.extraLink[col.key].text }}
                </a>
              </div>
            </template>
            <template v-else>
              <i
                tabindex="-1"
                class="zm-icon-ok"
                :aria-label="t('marketing.included')"
                v-if="scope.row[col.key] == true"
              ></i>
              <i
                tabindex="-1"
                class="zm-icon-minus"
                :aria-label="t('marketing.notIncluded')"
                v-else
              ></i>
              <template v-if="scope.row.desc">
                <div tabindex="-1" class="cell-desc" v-html="scope.row.desc" v-if="typeof scope.row.desc === 'string'"></div>
                <div tabindex="-1" class="cell-desc" v-html="scope.row.desc[col.key]" v-if="typeof scope.row.desc === 'object'"></div>
              </template>
              <div
                tabindex="-1"
                class="cell-desc"
                v-html="scope.row[`desc${idx+1}`]"
                v-if="scope.row.multiDesc && scope.row[`desc${idx+1}`]"
              ></div>
              <div tabindex="-1" class="cell-desc" v-if="col.key === 'enterprise' && scope.row.enterpriseDesc">
                <span class="cell-desc">{{ scope.row.enterpriseDesc }}</span>
              </div>
              <div v-if="isObject(scope.row.extraLink) && isObject(scope.row.extraLink[col.key]) && scope.row.extraLink[col.key]['text']">
                <a
                  class="comparison-extra-link__text"
                  tabindex="0"
                  :aria-label="scope.row.extraLink[col.key].text"
                  @click.prevent="scope.row.extraLink[col.key].callback && scope.row.extraLink[col.key].callback()"
                  @keydown.enter.prevent="scope.row.extraLink[col.key].callback && scope.row.extraLink[col.key].callback()"
                >
                  {{ scope.row.extraLink[col.key].text }}
                </a>
              </div>
            </template>
          </template>
        </template>
      </zm-table-column>
      <!--col config end-->
    </zm-table>
    <div v-if="showClose" class="comparison-new-fixed-desktop" aria-label="Close Comparison Chart">
      <div class="text" @click="closeTable" @keydown.enter.prevent="closeTable" tabindex="0">
        {{ t('closeComparisonChart')}}
        <i class="zm-icon-up"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { t } from '@/plugins/i18n';
import { WorkplaceComparison } from '@/datas/workspace-comparison';
import { isObject } from 'lodash';
import AutoExpireBadge from '@/components/AUTO_EXPIRE_BADGE';
import { fetchBasicConfig } from '@/apis'
import Cookies from 'js-cookie'
import { getCurrencySymbol } from '../ADDON_LEARN_MORE_DIALOG/money.js'

export default {
  name: 'CommonComparisonTable',
  components: {
    AutoExpireBadge,
  },
  props: {
    appName: {
      type: String,
      default: '',
    },
    tableProps: {
      type: Object,
      default: ()=> {}
    },
    comparisonProps: {
      type: Object,
      default: ()=> {}
    },
    colConfig: Array,
    showHeader: String,
    isCenter: Boolean,
    isAllowExpand: Boolean,
    mouseInToolTip: {
      type: Function,
      default: ()=> {},
    },
    resetTableData: Boolean,
    handleRowClick: Function,
    maxHeight: {
      default: 800,
    },
    defaultExpandRowKeys: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visibleFixed: false,
      treeData: []
    }
  },
  created () {
    this.fetchBasicConfig();
  },
  mounted() {
    this.addEventTab();
  },
  beforeDestroy() {
    this.removeEventTab();
  },
  computed: {
    showClose() {
      return this.isAppPricing && this.visibleFixed
    },
    isAppPricing() {
      return this.appName === 'pricing'
    },
    shouldReBuild() {
      return '' + this.comparisonProps?.hidePhone + this.comparisonProps?.showAdvancedSecurity
    }
  },
  watch: {
    appName: {
      immediate: true,
      handler(newV) {
        if (newV) {
          this.treeData = new WorkplaceComparison({
            ...this.comparisonProps,
            isAppPricing: this.isAppPricing
          }).build().resultGetter
        }
        this.$nextTick(() => {
          if (this.isAppPricing) {
            // pricing, default expand first
            let titleRow = this.$refs.comparisonTable?.$el.getElementsByClassName('title-row')[0];
            titleRow && titleRow.click();
          }
        });
      }
    },
    shouldReBuild: {
      handler(nv, ov) {
        if (nv !== ov) {
          this.treeData = new WorkplaceComparison({
            ...this.comparisonProps,
            isAppPricing: this.isAppPricing
          }).build().resultGetter
        }
      }
    },
  },
  methods: {
    isObject,
    t,
    addEventTab() {
      if (!this.showClose) {
        this.$el.addEventListener('keydown', this.eventTabHandleFn);
      }
    },
    eventTabHandleFn(event) {
      const closeBtnClass = 'zm-dialog__headerbtn';
      const firstThSpanClass = 'table-th-first-span';
      //By default, the first Th in the table can be selected by the tab key, but the rest of the content cannot be selected by the tab and can only be viewed with the Arrow key.
      if (event.key === 'Tab' && this?.$parent?.visible && !document.activeElement?.classList?.contains(closeBtnClass)) {
        const el = this.$el;
        const focusableElements = el.querySelectorAll('[tabindex="0"]');
        focusableElements.forEach(element => {
          element.setAttribute('tabindex', '-1');
        });
        const targetButton = this.$parent?.$el?.querySelector(`.${closeBtnClass}`);
        if (targetButton) {
          targetButton.focus();
          el.querySelector(`.${firstThSpanClass}`).setAttribute('tabindex', '0');
        }
        event.preventDefault();
      }
    },
    removeEventTab() {
      if (!this.showClose) {
        this.$el.removeEventListener('keydown', this.eventTabHandleFn);
      }
    },
    tableRowClassName ({ row }) {
      if (row.subTitle) {
        return 'title-row';
      } else {
        return '';
      }
    },
    closeTable() {
      let expandItem = document.querySelectorAll(
        '.title-row .zm-table__expand-icon--expanded'
      );
      if (expandItem.length) {
        expandItem.forEach((node) => {
          node.click();
        });
        this.visibleFixed = false;
      } else {
        return false;
      }
    },
    handleExpandChange() {
      //ZoomUi table component bug, hidden elements are not filtered for ax.
      this.$refs?.comparisonTable?.debouncedCreateOrUpdateGrid();
      this.$nextTick(() => {
        if (this.isAppPricing) {
        let expandItem = document.querySelectorAll(
        '.title-row .zm-table__expand-icon--expanded'
      );
        if (expandItem.length) {
          this.visibleFixed = true;
        } else {
          this.visibleFixed = false;
          }
        }
      })
    },
    handleRowClickDefault (row) {
      if (this.handleRowClick) {
        return this.handleRowClick(row);
      }
      if (row.subTitle) {
        const featureCol = document.querySelector(
          `.${row.id}-sub-title`
        );
        let cel = null;
        let expandBtn = null;
        if (featureCol) {
          cel = featureCol.parentElement;
        }
        if (cel) {
          expandBtn = cel.querySelector('.zm-table__expand-icon');
        }
        if (expandBtn) {
          expandBtn.click();
        }
        this.$nextTick(() => {
          if (this.isAppPricing) {
            let expandItem = document.querySelectorAll(
            '.title-row .zm-table__expand-icon--expanded'
          );
          if (expandItem.length) {
            this.visibleFixed = true;
          } else {
            this.visibleFixed = false;
          }
          }
        });
      }
    },
    arraySpanMethod ({ row, columnIndex }) {
      if (row.subTitle) {
        return columnIndex === 0 ? [1, 10] : [0, 0];
      }
    },
    fetchBasicConfig () {
      if (!this.appName) return;
      fetchBasicConfig().then(res => {
        if (!res?.exchangeRates) return;
        const { exchangeRates } = res;
        const _zm_currency = Cookies.get('_zm_currency') || 'USD'
        const currentDollars = exchangeRates.find(e => e.currency === _zm_currency);
        if (!currentDollars) return;
        const { priceForTenDollars, priceForTwoHundredDollars } = currentDollars;
        const currentCurrencyValue = {
          symbol: getCurrencySymbol(_zm_currency),
          priceForTenDollars,
          priceForTwoHundredDollars,
          _zm_currency
        }
        this.treeData = new WorkplaceComparison({
            ...this.comparisonProps,
            isAppPricing: this.isAppPricing,
            currentCurrencyValue
          }).build().resultGetter
      });
    }
  },
};
</script>
<style lang="scss">
.zm-table.comparison-table-new,
.zm-sticky-fixed {
color: #00053d;
td {
  text-align: center;
  .cell {
    padding: 8px;
  }
}
th div {
  padding: 0;
  overflow: visible;
}
.zm-table__body tbody td {
  border-bottom: 1px solid #eaeaf0;
}
.type-title {
  display: block;
  color: #0b5cff;
  font-weight: 400;
  font-size: 16px;
  padding: 5px 0;
}
.type-title-developer {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 25px;
  padding-top: 15px;
}
.type-price {
  min-height: 46px;
  margin-top: -15px;
  margin-bottom: 5px;
}
.type-price-free {
  line-height: 40px;
  margin-top: -15px;
  margin-bottom: 5px;
}
.zm-table__row.title-row{
  cursor: pointer;
    background: #fff;

  td {
    border-bottom: 1px solid #eaeaf0;
    background: #fff;
    .cell {
      display: flex;
      justify-content: left;
      flex-direction: row-reverse;
      .zm-table__expand-icon {
        position: relative;
        right: auto;
        margin-top: 5px;
        i {
          font-weight: bold;
        }
      }
    }
  }
}
.new-price-wrapper {
  .new-price {
    padding: 0;
    .rate {
      font-weight: 400;
      font-size: 14px;
    }
    .price-part {
      margin: 0;
      font-size: 14px;
      padding: 0;
      vertical-align: middle;
      .currency-flag {
        margin-top: 10px;
        line-height: 21px;
        font-size: 12px;
        font-weight: 600;
      }
    }
    .price-num {
      line-height: 42px;
      font-size: 18px;
      font-weight: 600;
      .subtext {
        margin-top: 10px;
        font-weight: 600;
      }
    }
  }
}
&::before {
  height: 0;
}
& > thead {
  & > tr {
    border-bottom: 1px solid rgba(35, 35, 51, 0.2);
  }
  th {
    font-size: 16px;
    text-align: center;
    line-height: 19px;
    letter-spacing: 0.5px;
    padding: 20px 0;
  }
}
td {
  border-bottom: 0;
  margin-top: 50px;
}
th.comparison-table-header-cell .cell {
  padding: 0 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: #515079;
  margin-bottom: 8px;
  text-transform: capitalize;
  .rate {
    text-transform: initial;
  }
}
.feature-col {
  text-align: left;
  color: #00053d;
  font-size: 16px;
  .cell {
    text-align: left;
  }
  .table-feature-title {
    vertical-align: text-bottom;
  }
  .table-feature-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 3px;
    margin-top: 3px;
    &.icon-sessions {
      background: url('~@/assets/developer/sessions.svg') no-repeat;
    }
    &.icon-minutes {
      background: url('~@/assets/developer/minutes.svg') no-repeat;
    }
    &.icon-storage {
      background: url('~@/assets/developer/storage.svg') no-repeat;
    }
    &.icon-audio {
      background: url('~@/assets/developer/audio.svg') no-repeat;
    }
    &.icon-connector {
      background: url('~@/assets/developer/connector.svg') no-repeat;
    }
    &.icon-transcription {
      background: url('~@/assets/developer/transcription.svg') no-repeat;
    }
    &.icon-subscription {
      background: url('~@/assets/developer/subscription.svg') no-repeat;
    }
    background-size: contain;
  }
}
.zm-table__placeholder {
  display: none;
}

.button-icon {
  height: 26px;
  line-height: 24px;
  vertical-align: text-bottom;
  background-color: transparent;
  border: none;
}
.zm-icon-ok {
  font-size: 26px;
  color: #0b5cff;
}
.zm-icon-minus {
  font-size: 19px;
  color: rgba(4, 4, 19, 0.56);
  opacity: 0.6;
}
.type {
  text-align: left;
  padding-left: 50px;
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 16px;
  line-height: 23px;
  color: #232333;
}
.feature-content {
  &.sub-title {
    margin-left: 0;
  }
}
.feature-content.sub-title {
  margin-left: 0;
  text-transform: capitalize;
  font-family: "Happy Display", "Internacional", "Helvetica", "Arial";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 150%;
  color: #0b5cff;
}
.feature-content.sub-text {
  hyphens: auto;
  word-break: break-word;
}
.feature-content {
  margin-right: 5px;
}
.zm-icon-info-outline {
  color: #4f90ee;
  vertical-align: middle !important;
}
.feature-title-wrapper {
  text-align: left;
  display: block;
}
.zm-table__expand-icon {
  position: absolute;
  right: 37px;
  font-size: 16px;
  color: #0b5cff;
}
.cell-wrapper {
  text-align: left;
  padding-left: 15px;
}
}

.zm-table.comparison-table-disabled-expand {
.zm-table__expand-icon {
  display: none;
}
}
.zm-table.comparison-table-new .comparison-table-header,
.zm-table.zm-sticky-fixed .comparison-table-header {
th {
  padding: 2px 0;
}
th.feature-col {
  text-align: left;
  .cell {
    text-align: left;
  }
}
th.comparison-table-header-cell .cell {
  padding: 0 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: #515079;
  margin-bottom: 8px;
  text-transform: capitalize;
  .feature-content.sub-title {
    text-align: left;
    margin-left: 0;
    text-transform: uppercase;
    font-weight: bold;
  }
}

.new-buy-btn {
  display: block;
  padding-left: 0;
  padding-right: 0;
  margin-top: -20px;
}
a.buy-plan-link {
  padding-left: 30px;
  padding-right: 30px;
  max-width: 100%;
  font-size: 14px;
  color: #fff;
  white-space: break-spaces;
  &.zm-button--plain {
    color: #0b5cff;
    background-color: #ffffff;
    border-color: #0b5cff;
  }
}

.plain-btn-plan {
  a.buy-plan-link {
    color: #0b5cff;
    background-color: #ffffff;
    border: 1px solid #0b5cff;
  }
}

.zoomOneInclude {
  color: #00053D;
  font-weight: 400;
  font-size: 12px;
  line-height: 120%;
  margin-top: 20px;
  padding-bottom: 10px;
}
}
.zm-table.comparison-table-new .comparison-table-header {
th {
  .cell {
    display: block;
    text-align: center;
  }
}
tr {
  .cell {
    display: block;
    text-align: center;
  }
}
}
.comparison-container {
position: relative;
padding-bottom: 15px;
.comparison-new-fixed-desktop {
  position: absolute;
  bottom: -8px;
  left: -20px;
  text-align: center;
  padding: 0;
  line-height: 53px;
  height: 53px;
  font-weight: 500;
  font-size: 14px;
  color: #0b5cff;
  width: calc(100% + 40px);
  box-shadow: 0px -4px 4px 0 rgba(0, 0, 0, 0.04);
  border-radius: 0 0 20px 20px;
  .text {
    width: fit-content;
    cursor: pointer;
    font-size: 14px;
    margin: 0 auto;
  }
}
}

.comparison-container-has-padding {
padding-bottom: 53px;
}
.zm-table.comparison-table-new td a.comparison-extra-link__text {
  display: block;
  line-height: 1.2;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  color: #0B5CFF;
  &.comparison-extra-link__disabled {
    pointer-events: none;
    color: #666487;
  }
}

</style>
